import './style.scss';
import MenuItem from '../../components/schoolsDinam/menuItem';
import { getSchools } from '../../API/apiService';
import { useEffect, useState } from 'react';
import WelcomeUser from '../../components/welcomeUser';
import {constants} from "../../config/constants";

function PrincipalMenu() {
  const userId = localStorage.getItem(constants.USER_ID);
  const [schools, setSchools] = useState([]);

  async function getBasicInfo() {
    if (userId) {
      const data = await getSchools(userId);
      if (data) {
        setSchools(data);
      }
    }
  }

  useEffect(() => {
    console.log('efect');
      getBasicInfo();
  }, []);
  return (
    <>
      <section className='schools'>
        {schools && (
          <div className='schools__content content'>
            <div className='content__welcome'>
              <WelcomeUser schoolsList={true}></WelcomeUser>
            </div>
            <div className='content__wrapper'>
              {schools &&
                schools.length > 0 &&
                schools.map((school, i) => (
                  <MenuItem key={i} uid={i} school={school} />
                ))}
            </div>
          </div>
        )}
      </section>
    </>
  );
}

export default PrincipalMenu;